import { render, staticRenderFns } from "./SettingsAnnouncementConfigView.vue?vue&type=template&id=007901b8&scoped=true&"
import script from "./SettingsAnnouncementConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsAnnouncementConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAnnouncementConfigView.vue?vue&type=style&index=0&id=007901b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007901b8",
  null
  
)

export default component.exports